
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";

import "./project-card-carousel.less";
import {dataService} from "@/services/data/category-data-service";

@Component
export default class ProjectCardCarousel extends Vue {
  @Prop() images!: String[];
  @Prop() lifeDetailsUrl!: string;

  private showCarousel = false;
  private imgRatio = 16 / 9;
  private sortedImages = null;
  private subscription;
  private data ={
    category: dataService.category != null ? dataService.category: {id:0},
    country: dataService.country != null ? dataService.country: {id:0},
    paginator: dataService.paginator != null ? dataService.paginator: {id:0}
  };

  getLinkParameter(){
    let urlParameter = "?category="+this.data.category.id+"&country="+this.data.country.id;
    return urlParameter;
  }
  async mounted() {
    this.subscription = dataService.categoryData.data.subscribe(
            (ev) => {
              if(ev.event == 'update-attributes'){
                this.data = ev.data;
              }
            }
    );
    await this.$nextTick();

    this.setHeight();
    $(window).resize(this.setHeight);
  }

  updated() {
    this.setHeight();
  }

  loaded(ev) {
    const img = $(ev.target);
    if (img.length) {
      img
        .eq(0)
        .addClass(
          img.get(0).naturalWidth! / img.get(0).naturalHeight! < this.imgRatio
            ? "narrow"
            : "wide"
        );
    }
  }

  private calculateHeight() {
    //@ts-ignore
    const container = $(this.$refs.imageContainer);
    //@ts-ignore
    const width = container.width();
    return width! / this.imgRatio;
  }

  private setHeight() {
    //@ts-ignore
    const container = $(this.$refs.imageContainer);
    //@ts-ignore
    container.height(this.calculateHeight);
  }

  private next() {
    //@ts-ignore
    const carousel = $(this.$refs.projectCarousel);
    (carousel as any).slick("slickNext");
  }

  private prev() {
    //@ts-ignore
    const carousel = $(this.$refs.projectCarousel);
    (carousel as any).slick("slickPrev");
  }
  navigate(url) {
    this.navigated(url+this.getLinkParameter());
    location.href = url+this.getLinkParameter();
  }

  @Watch("showCarousel")
  private initCarousel() {
    setTimeout(() => {
      //@ts-ignore
      const carousel = $(this.$refs.projectCarousel);

      (carousel as any)
        .slick({
          dots: false,
          infinite: true,
          speed: 600,
          autoplay: false,
          arrows: false,
          autoplaySpeed: 7000,
          slidesToShow: 1,
          adaptiveHeight: false
        })
        .on("setPosition", (event, slick) => {
          slick.$slideTrack.height(this.calculateHeight());
        });
      this.next();
    }, 10);
  }

  @Emit("navigatedTo")
  private navigated(url) {}
}
